<template>
    <router-view></router-view>
</template>

<script>

export default {
  metaInfo () {
    return {
      title: `${this.$i18n.t("METAINFO.dashboard.tab_title")}`,
    }
  },
  data() {
    return {
    };
  },
};
</script>
